import clsx from 'clsx';
import { CopyIcon, EditIcon, EyeIcon } from '../../../../../shared/ui/icons';
import { IconButton } from '../../../../../shared/ui/icon-button/IconButton';
import { ChannelBadge } from '../../../../../shared/ui/channel-badge/ChannelBadge';
import { TemplateStatusBadge } from '../../template-status-badge/TemplateStatusBadge';
import { LanguageFlag } from '../../language-flag';
import { TemplateUpdatedLabel } from '../../template-updated-label/TemplateUpdatedLabel';
import { CHANNEL } from '../../../constants/messageTemplateKeys';
import { isLiveTemplateStatus } from '../../../lib/isLiveTemplateStatus';
import styles from '../TemplateCard.module.css';

export function TemplateCardHeader({
  status,
  channel,
  language = null,
  updatedLabel,
  showActions,
  canEdit = false,
  onEdit,
  onCopy,
  onPreview,
}) {
  const channelKey = String(channel || '')
    .trim()
    .toLowerCase();
  const showChannelBadge = channelKey === CHANNEL.SMS || channelKey === CHANNEL.MMS;
  const showLanguageFlag = isLiveTemplateStatus(status);

  return (
    <div className={clsx(styles.header)}>
      <div className={clsx(styles.headerLeft)}>
        {showLanguageFlag ? <LanguageFlag language={language} /> : null}

        <TemplateStatusBadge status={status} />

        {showChannelBadge && <ChannelBadge channel={channel} />}
      </div>

      <div className={clsx(styles.headerRight)}>
        {updatedLabel ? (
          <TemplateUpdatedLabel className={clsx(styles.updated)}>
            Updated {updatedLabel}
          </TemplateUpdatedLabel>
        ) : null}

        {showActions ? (
          <div className={clsx(styles.actions)}>
            <IconButton
              ariaLabel="View template"
              className={clsx(styles.actionButton)}
              size="md"
              onClick={onPreview}
            >
              <EyeIcon />
            </IconButton>
            {canEdit ? (
              <>
                <IconButton
                  ariaLabel="Edit template"
                  className={clsx(styles.actionButton)}
                  size="md"
                  onClick={onEdit}
                >
                  <EditIcon />
                </IconButton>
                <IconButton
                  ariaLabel="Copy template"
                  className={clsx(styles.actionButton)}
                  size="md"
                  onClick={onCopy}
                >
                  <CopyIcon />
                </IconButton>
              </>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
}
